<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        @select="handleSelect"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import bus from '../bus'
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/assets/styles/variables.scss'

export default {
  components: { SidebarItem,Logo },
  data() {
    return {
      sidebarValue: true,
      keypath: ''
    }
  },
  computed: {
    ...mapGetters(['sidebar']),
    routes() {
      return this.$store.getters.routerList
    },
    activeMenu() {
      
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }

      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  watch: {
    keypath(newVal, oldVal) {
      if (oldVal) {
        bus.$emit('closeOthers')
      }
    }
  },
  methods: {
    collapseChage() {
      this.$store.dispatch('app/toggleSideBar')
    },
    handleSelect(key, keyPath) {
      this.keypath = key
    }
  },
  mounted(){
    this.keypath=this.$route.path
  }
}
</script>
<style scoped>
.sidebar-el-switch-collapse {
  width: 100%;
  padding-left: 10%;
  padding-top: 20px;
}
.sidebar-el-switch {
  width: 100%;
  padding-left: 10%;
  padding-top: 20px;
}
</style>
